interface ISeparator {
  sector?: boolean;
}

export const Separator = ({ sector = false }: ISeparator) =>
  sector ? (
    <>
      <div className="border border-l-[0.5px] border-solid border-[#f1f1f8]" />
    </>
  ) : (
    <hr className="my-8 h-px border-none bg-[#f1f1f8] outline-none" />
  );

Separator.displayName = 'Separator';
